/**
 * Human-readable payment / subscription label for admin campaign views.
 */
export function formatAdminCampaignPaymentStatus(subscriptionStatus) {
    const status = String(subscriptionStatus || '').toLowerCase();

    switch (status) {
        case 'launch_unpaid':
        case 'pending_payment':
            return 'Not paid';
        case 'launch_paid':
        case 'pending_approval':
        case 'pending_activation':
            return 'Paid — awaiting approval';
        case 'active':
            return 'Paid — active';
        case 'suspended':
            return 'Suspended';
        case 'prepaid_reserved':
            return 'Prepaid — awaiting creatives';
        default:
            if (!status) {
                return 'Unknown';
            }
            return status.replace(/_/g, ' ');
    }
}

export function isUnpaidCampaignStatus(subscriptionStatus) {
    const status = String(subscriptionStatus || '').toLowerCase();
    return status === 'launch_unpaid' || status === 'pending_payment';
}
